export const StandardPriorityIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_7095_22174)">
        <path d="M4.6665 6.66699H11.3332" stroke="#FF8447" strokeLinecap="round" />
        <path d="M4.6665 9.33398H11.3332" stroke="#FF8447" strokeLinecap="round" />
      </g>
      <defs>
        <clipPath id="clip0_7095_22174">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
